<template>
  <div>
    <!-- 预设任务 -->
    <baseBreadcrumb :page="$t('message.presetTaskList')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="tab">
        <div class="tabOpt" :class="{ act: datas.status === item.filter_value }" v-for="(item, index) in listTab"
          :key="index" @click="search(item)">
          {{ item.name }}
          <span v-if="index > 0">({{ item.total }})</span>
        </div>
      </div>
      <div class="search">
        <div class="left">
          <!-- 执行人 -->
          <div class="item">
            <el-select v-model="datas.execute_by" :placeholder="$t('message.executor')" clearable filterable>
              <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--任务类型  -->
          <div class="item"> <el-select v-model="datas.type" :placeholder="$t('message.taskType')" clearable filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select></div>
          <!-- 订单配送单 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderDistribution')" clearable></el-input>
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search({ filter_value: datas.status })">{{ $t('message.search')
            }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>

      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 任务基础信息 -->
          <li class="flex15">{{ $t('message.taskBasicInformation') }}</li>
          <!-- 具体要求 -->
          <li class="flex2">{{ $t('message.specificRequirements') }}</li>
          <!-- 抽查项目 -->
          <li class="flex15">{{ $t('message.spotCheckItems') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 操作 -->
          <li class="flex05">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 任务基础信息 -->
          <li class="flex15">
            <div class="template">
              <p> 任务编号：{{ item.spot_sn }}</p>
              <p>来源：{{ item.created_from }}</p>
              <p> 登记时间：{{ item.start_at }}</p>
              <p> 预设登记人：{{ item.created_by_admin ? item.created_by_admin.realname : '' }}</p>
              <p> 执行人：{{ item.execute_by_admin ? item.execute_by_admin.realname : '' }}</p>
              <p> 消息同步推送：<span v-for="name in item.msg_receive" :key=name.id>{{ name.realname }}、</span></p>
            </div>
          </li>
          <!-- 具体要求 -->
          <li class="flex2">
            <div class="template">
              <p> 任务类型：{{ item.type_name }} </p>
              具体要求：<span v-for="(desc, descIndex) in item.desc" :key="descIndex">({{ descIndex + 1 }}){{ desc }},</span>
            </div>
          </li>
          <!-- 抽查项目 -->
          <li class="flex15">
            <div class="template">
              <div class="item" v-for="(spot, spotIndex) in item.spot_detail" :key="spotIndex">
                <div class="type">
                  <div v-if="[1, 2, 3, 10].includes(item.type)">
                    <p v-if="spot.order_detail">
                      <router-link :to="'/orderPaymentDetail?order_sn=' + spot.order_detail.order_sn" target="_blank"
                        class="a-link">
                        {{ spot.order_detail.order_sn }}- {{ spot.order_detail.sorting }}
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[4, 5, 6].includes(item.type)">
                    <p>
                      <router-link :to="'/porderDetail?porder_sn=' + spot.porder_detail.porder_sn" target="_blank"
                        class="a-link">
                        {{ spot.porder_detail.porder_sn }}
                      </router-link>
                    </p>
                    <p>
                      <router-link :to="'/orderPaymentDetail?order_sn=' + spot.porder_detail.order_sn" target="_blank"
                        class="a-link">
                        {{ spot.porder_detail.order_sn }}-NO{{ spot.porder_detail.order_detail.sorting }}
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[7].includes(item.type)">
                    <p>
                      <router-link :to="'/porderDetail?porder_sn=' + spot.porder_detail.porder_sn" target="_blank"
                        class="a-link">
                        {{ spot.porder_detail.porder_sn }}-{{ spot.number }}箱
                      </router-link>
                    </p>
                  </div>
                  <div v-if="[8].includes(item.type)">
                    <p> <router-link :to="'/porderDetail?porder_sn=' + spot.porder_detail.porder_sn" target="_blank"
                        class="a-link">
                        {{ spot.porder_detail.porder_sn }}
                      </router-link></p>
                  </div>
                  <div v-if="[9].includes(item.type)">
                    <p>{{ spot.org_name }}</p>
                  </div>

                </div>

              </div>
            </div>
          </li>

          <!-- 状态 -->
          <li>
            <el-tag v-if="item.status == -1">
              {{ item.status_name }}
            </el-tag>
            <el-tag type="primary" v-else-if="item.status == 0" class="primary">
              {{ item.status_name }}
            </el-tag>
            <el-tag type="success" v-else-if="item.status == 10">
              {{ item.status_name }}
            </el-tag>
          </li>
          <!-- 操作 -->
          <li class="flex05">
            <!-- 取消 -->
            <el-button type="primary" class="del" size="mini" @click="spotCancel(item.spot_sn)"
              v-if="item.status == 0">{{ $t('message.cancel') }}</el-button>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      time: [],
      datas: {
        page: 1,
        pageSize: 20,
        type: "",
        execute_by: "",
        order_sn: this.$route.query.order_sn || "",

        status: ''
      },
      options: [],
      tableData: [],
      total: 0,
      listTab: [],
      adminList: [],
      // 创建任务
      taskType: '',
      dialogVisible: false,
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    this.$api.spotCheckApi.spotTypeList().then(res => {
      this.options = res.data
    })

    this.presetList()
    this.presetListTab()

  },
  methods: {
    // 配置列表tab
    presetListTab() {
      this.$api.spotCheckApi.presetListTab().then(res => {
        // res.data[2].status = 2
        this.listTab = res.data

      })
    },
    // 列表
    presetList() {
      this.$api.spotCheckApi.presetList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search(item) {
      if (item) {
        this.datas.status = item.filter_value
      }
      this.datas.page = 1;
      this.presetList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        type: "",
        execute_by: "",
        order_sn: "",
        status: ''
      };
      this.presetList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.presetList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.presetList();
    },
    //取消抽查任务
    spotCancel(spot_sn) {
      let datas = {
        spot_sn,
        cancel_reason: '手动关闭预设任务'
      }
      this.$confirm('是否取消该预设任务，取消后记录将不在保留?', '提示', {
        confirmButtonText: '确认取消',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.spotCancel(datas).then(res => {
          this.$message.success(res.msg)
          this.presetList();
          this.presetListTab()
        });
      }).catch(() => {

      });

    },

  }
}
</script>
<style lang='scss' scoped>
.tab {
  display: flex;
  background: #F8F8F8;
  align-items: center;
  border-bottom: 1px solid #edeff4;
  margin-bottom: 20px;

  .tabOpt {
    height: 50px;
    min-width: 160px;
    padding: 0 30px;
    font-size: 18px;
    line-height: 50px;
    margin-bottom: -2px;
    box-sizing: border-box;
    text-align: center;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
    cursor: pointer;


  }

  .act {
    color: #b4272d;
    border-top: solid 2px #b4272d;
    border-left: solid 1px #edeff4;
    border-right: solid 1px #edeff4;
    border-bottom: solid 2px #f8f8f8;
    background-color: #f8f8f8;
  }
}

.search {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }
}

.table {
  margin-top: 20px;

  ol {
    height: 50px;
  }

  ul {
    padding: 20px 0;
    background-color: #fff;
  }

  .flex05 {
    flex: 0.6;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .template {
    width: 100%;

    p {
      line-height: 22px;
    }


    .item {
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 4px;
      margin-bottom: 10px;

      .type {
        position: relative;
        font-weight: 600;

        .el-button {
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      .status {
        margin: 10px 0;
      }



      &:nth-last-child(1) {
        margin: 0;
      }


    }
  }
}

.row {
  display: flex;
  padding: 0 10px;

  .label {
    margin-right: 10px;
    line-height: 40px;

    span {
      color: red;
      margin-right: 5px;
    }
  }
}
</style>